import { concat, get } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { isTrue } from 'src/utils/helper';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const FoerdervoraussetzungAntragEbusse: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Fördervoraussetzungen' description={PLATZHALTER_TEXT} />

			<CreateForm formStruc={formStruc(application)} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};

export default FoerdervoraussetzungAntragEbusse;

const formStruc = (application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Wurde_Vorhaben_Bereits_Begonnen,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Ueberschreiten_Gesamtausgaben_Bagatellgrenze,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0106609860_ekt_Mit_Eigenem_Verkehrswert,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0061669365_Um_Eine_Kumulierte_Beihilfe,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		...((
			isTrue(
				get(
					application,
					P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0061669365_Um_Eine_Kumulierte_Beihilfe.path,
					'',
				),
			)
		) ?
			[
				{
					fields: [
						{
							...P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0267430189_falls_Ja_Es_Handelt_Sich_Um,
							type: 'multiSelect',
						},
					],
					userProps: { direction: 'column', columnToDivide: 2 },
				},
			]
		:	[]),
		{
			fields: [
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0206799458_Lade_Betankungsinfrastruktur,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0234791143_e_Ohne_Fossile_Zusatzheizung,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0110393781_estens_5_Fahrgastsitzplaetze,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0178273940_Den_Vorgaben_Beruecksichtigt],
			userProps: { direction: 'column', columnToDivide: 2 },
		},
		{
			fields: [
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0112329284_hre_In_Betrieb_Gehalten_Wird,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0231484162_htet_Werden_Soll_Eigentuemer,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0074083652_es_Vermieters_Ist_Beigefuegt,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0253277730_Diskriminierungsfrei_Nutzbar],
			userProps: { direction: 'column', columnToDivide: 2 },
		},
		{
			fields: [
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0103731710_reien_Ausschreibung_Gewonnen,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0109243156_r_Wasserstoff_Bereitgestellt,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucFoerdervoraussetzungAntragEbusse = (application: any) => {
	return concat(formStruc(application));
};
